import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MotorcycleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"motorcycle"}/>
}
